export const StatusUnsimplifier = {
  MAPPING: {
    i: 'id',
    ca: 'created_at',
    ra: 'revised_at',
    irti: 'in_reply_to_id',
    irta: 'in_reply_to_account_id',
    s: 'sensitive',
    st: 'spoiler_text',
    v: 'visibility',
    l: 'language',
    u: 'uri',
    ul: 'url',
    drc: 'direct_replies_count',
    rc: 'replies_count',
    rbc: 'reblogs_count',
    p: 'pinnable',
    pbg: 'pinnable_by_group',
    fc: 'favourites_count',
    qoi: 'quote_of_id',
    ea: 'expires_at',
    hq: 'has_quote',
    bci: 'bookmark_collection_id',
    qc: 'quotes_count',
    rid: 'reaction_id',
    rcs: 'reactions_counts',
    ir: 'is_reply',
    ai: 'account_id',
    mai: 'media_attachment_ids',
    ci: 'conversation_id',
    robi: 'reblog_of_id',
    gi: 'group_id',
    sci: 'status_context_id',
    pci: 'preview_card_id',
    pi: 'poll_id',
    fvd: 'favourited',
    rbgd: 'reblogged',
    m: 'muted',
    c: 'content',
    t: 'text',
    md: 'markdown',
    rb: 'reblog',
    q: 'quote',
    a: 'account',
    g: 'group',
    sc: 'status_context',
    ma: 'media_attachments',
    om: 'ordered_mentions',
    m: 'mentions',
    tg: 'tags',
    e: 'emojis',
    pc: 'preview_card',
    pp: 'preloadable_poll',
    cr: 'can_reply',
    rg: 'reply_group',
  },

  unsimplifyKey(simplifiedKey) {
    return this.MAPPING[simplifiedKey] || simplifiedKey;
  },

  unsimplify(data) {
    if (Array.isArray(data)) {
      return data.map(this.unsimplifyObject.bind(this));
    } else {
      return this.unsimplifyObject(data);
    }
  },

  unsimplifyObject(obj) {
    const newObj = {};
    for (const key in obj) {
      const unsimplifiedKey = this.unsimplifyKey(key);
      newObj[unsimplifiedKey] = obj[key];
    }
    return newObj;
  }
};

